export async function callClaude(cluster, domain, competitors, minusWords = [], version = "") {
  const kwList = cluster.keywords.slice(0, 15).map(k => `${k.keyword} (${k.frequency})`).join(", ");
  const compCtx = competitors?.length ? `\nКонкуренты: ${competitors.join(", ")}` : "";

  const minusBlock = minusWords.length > 0 ? `\nЗАБОРОНЕНІ СЛОВА (НІКОЛИ не використовуй ці слова та будь-які їх форми):\n${minusWords.join(", ")}\nЯкщо слово було в попередньому варіанті — заміни його на синонім або перефразуй.\n` : "";

  const sysPrompt = `Ты — экспертный SEO-копирайтер. Создай Title, H1 и Meta Description для веб-страницы.
${minusBlock}
КРИТИЧЕСКИ ВАЖНЫЕ ПРАВИЛА (нарушение любого = провал):

TITLE:
- ОБЯЗАН содержать ВЧ-ключ "${cluster.hfKeyword}" — дословно или в близкой морфологической форме
- ОБЯЗАН содержать МИНИМУМ 3 РАЗНЫХ ключа из списка ниже, НАЧИНАЯ С САМЫХ ВЫСОКОЧАСТОТНЫХ и далее по убыванию частоты (ВЧ-ключ считается одним из трёх). Чем больше ключей — тем лучше, стремись к 4-5
- Длина: СТРОГО НЕ МЕНЕЕ 100 СИМВОЛОВ. Это АБСОЛЮТНЫЙ МИНИМУМ. Оптимально 100-120 символов. Title КОРОЧЕ 100 символов = ПОЛНЫЙ ПРОВАЛ, ПЕРЕДЕЛЫВАЙ. Считай символы! Если получилось меньше 100 — добавь ещё ключи из списка (по убыванию частоты) и коммерческие слова (купить, цена, оптом, доставка, Украина)
- РАСПРЕДЕЛЯЙ ключи РАВНОМЕРНО по всему Title — в начале, в середине и в конце. НЕ ставь все ключи подряд в начало. Пример плохого: "Стаканы бумажные одноразовые оптом купить — доставка по Украине". Пример хорошего: "Стаканы бумажные оптом — купить одноразовые стаканчики с доставкой по Украине"
- ЗАПРЕЩЕНО использовать слова: недорого, дешево, дёшево, низкие цены, доступные цены и их синонимы
- ЗАПРЕЩЕНО в Title: эмодзи, точки, вертикальные палки "|", двоеточия
- Title = одно слитное естественное предложение, разделители — только тире "—" или запятые

H1:
- H1 = ТОЧНОЕ прямое вхождение ВЧ-ключа "${cluster.hfKeyword}" БЕЗ ИЗМЕНЕНИЙ
- НЕ склоняй, НЕ спрягай, НЕ меняй форму слов — копируй ключ КАК ЕСТЬ
- Это критически важно для SEO — прямое вхождение даёт максимальный вес

DESCRIPTION:
- ОБЯЗАН содержать МИНИМУМ 3 РАЗНЫХ ключа из списка
- Длина: 120-180 символов
- Связное предложение с призывом к действию
- ОБЯЗАТЕЛЬНО добавь 1-2 эмодзи (✅🔥📦💰⭐🚀✨) для привлечения внимания

ОБЩЕЕ:
- Язык = язык ключей
- Ключи можно склонять/спрягать
- НЕ повторяй ключ дважды в одном поле
- НЕ добавляй название бренда/сайта

В used_keywords перечисли ТОЛЬКО те ключи которые использовал В TITLE.

ОТВЕТ: ТОЛЬКО валидный JSON, БЕЗ КАКОГО-ЛИБО ТЕКСТА ДО ИЛИ ПОСЛЕ. Никаких пояснений, комментариев, слов "Давайте", "Вот" и т.п. Начинай ответ СРАЗУ с символа {
ВЕРНИ ТОЛЬКО JSON-объект без преамбулы, без размышлений, без markdown. Первый символ ответа = "{", последний = "}".
ФОРМАТ: {"title":"...","h1":"...","description":"...","used_keywords":["ключ1"],"notes":""}`;

  const top3 = cluster.keywords.slice(0, 5).map(k => k.keyword).join(", ");
  const userPrompt = `Домен: ${domain}${version ? `\nВерсія сайту: ${version}. Генеруй контент саме для цієї версії.` : ""}
URL: ${cluster.url}

ВЧ-КЛЮЧ (обязательно в Title): ${cluster.hfKeyword} (частота: ${cluster.hfFreq})
ТОП-5 ключей для Title: ${top3}

Все ключи (по частотности): ${kwList}${compCtx}

Сгенерируй Title (МИНИМУМ 100 символов! Включи ВЧ-ключ + минимум 3 других ключа ПО УБЫВАНИЮ ЧАСТОТЫ), H1 (из самого частотного ключа) и Description (мин 3 ключа). ПЕРЕД ответом ПОСЧИТАЙ символы Title — если меньше 100, ДОБАВЬ ещё ключи!`;

  const token = localStorage.getItem("metago_token");
  const resp = await fetch("/api/claude", {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({
      model: "claude-sonnet-4-6",
      max_tokens: 1000,
      system: sysPrompt,
      messages: [{ role: "user", content: userPrompt }]
    })
  });

  if (!resp.ok) {
    const errText = await resp.text().catch(() => "");
    throw new Error(`API ${resp.status}: ${errText.slice(0, 150)}`);
  }

  const data = await resp.json();
  const text = data.content?.find(b => b.type === "text")?.text || "";
  let cleaned = text.replace(/```json\s*/gi, "").replace(/```/g, "").trim();
  let result;
  try { result = JSON.parse(cleaned); } catch {
    const f = cleaned.indexOf("{");
    const l = cleaned.lastIndexOf("}");
    if (f >= 0 && l > f) {
      try { result = JSON.parse(cleaned.slice(f, l + 1)); } catch { result = null; }
    }
  }
  if (!result) throw new Error("JSON parse error: " + text.slice(0, 100));

  // Post-process: remove commercial words from title/h1 start
  const stripCommercial = (str) => {
    if (!str) return str;
    let t = str.trim();
    let prev = "";
    while (prev !== t) {
      prev = t;
      t = t.replace(/^[\s"«]*?(купити|купить|замовити|заказать|ціна|цена|ціни|цены|продаж|продажа|продажі|продам|недорого|дешево|дешеві|бу|б\/у)\s+/i, "");
    }
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : t;
  };

  result.title = stripCommercial(result.title);
  // H1 — force exact HF keyword, strip geo
  if (cluster.hfKeyword) {
    result.h1 = cluster.hfKeyword
      .replace(/\s+(в\s+)?(київ|киев|україн[іаеу]?|украин[аеуы]?|одес[іаеу]?|харків|харьков|львів|львов|дніпр[іоеу]?|днепр[аоеу]?|запоріжж[яі]?|запорож[ьеъ]?[яе]?)\s*/gi, " ")
      .replace(/\s+/g, " ").trim();
  }

  // Ensure domain at end of title
  if (result.title && domain && !result.title.includes(domain)) {
    result.title = result.title.replace(/\s*[|—–-]\s*$/, "") + " — " + domain;
  }

  return result;
}

export function validateMeta(meta, cluster) {
  const issues = [];
  if (!meta.title || !meta.description) { issues.push("Нет title/description"); return issues; }

  const titleLow = meta.title.toLowerCase();
  const descLow = meta.description.toLowerCase();
  const allKws = cluster.keywords.map(k => k.keyword.toLowerCase());

  if (!titleLow.includes(cluster.hfKeyword.toLowerCase())) {
    const hfWords = cluster.hfKeyword.toLowerCase().split(/\s+/);
    const hfFound = hfWords.filter(w => w.length > 3 && titleLow.includes(w.slice(0, Math.max(4, w.length - 2))));
    if (hfFound.length < Math.ceil(hfWords.length * 0.6)) {
      issues.push("ВЧ-ключ '" + cluster.hfKeyword + "' не в Title");
    }
  }

  let titleKwCount = 0;
  allKws.forEach(kw => {
    const words = kw.split(/\s+/).filter(w => w.length > 3);
    const found = words.filter(w => titleLow.includes(w.slice(0, Math.max(4, w.length - 2))));
    if (found.length >= Math.ceil(words.length * 0.5)) titleKwCount++;
  });
  if (titleKwCount < 3) issues.push("Title: менее 3 ключей (найдено " + titleKwCount + ")");

  let descKwCount = 0;
  allKws.forEach(kw => {
    const words = kw.split(/\s+/).filter(w => w.length > 3);
    const found = words.filter(w => descLow.includes(w.slice(0, Math.max(4, w.length - 2))));
    if (found.length >= Math.ceil(words.length * 0.5)) descKwCount++;
  });
  if (descKwCount < 3) issues.push("Desc: менее 3 ключей (найдено " + descKwCount + ")");

  if (meta.title.length > 140) issues.push("Title длинный (" + meta.title.length + ")");
  if (meta.title.length < 100) issues.push("Title короткий (" + meta.title.length + "с, нужно 100+)");
  if (meta.description.length > 220) issues.push("Desc длинный (" + meta.description.length + ")");
  if (meta.description.length < 80) issues.push("Desc короткий (" + meta.description.length + ")");

  return issues;
}
